export default [
    {
        path: '/menu-access-blocks',
        name: 'menuAccessBlockIndex',
        component: () => import('./pages/Index'),
        meta: {
            title: 'Bloqueio de Acesso a Menus',
            icon: 'mdi-lock-clock',
            breadcrumbs: [
                { text: 'Bloqueio de Acesso a Menus', disabled: true }
            ]
        }
    }
]
